require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-j-kevin-ryan-financial-center-chief-executive-officer-retires.json") })
        }
      }, "path---articles-j-kevin-ryan-financial-center-chief-executive-officer-retires");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-j-kevin-ryan-financial-center-chief-executive-officer-retires!./.cache/json/articles-j-kevin-ryan-financial-center-chief-executive-officer-retires.json
// module id = 1693
// module chunks = 231608221292675